<template>
  <div class="dict-manage">
    <el-tabs v-model="activeTab" type="border-card">
      <!-- 字典类型管理 -->
      <el-tab-pane label="字典类型" name="type">
        <div class="toolbar">
          <el-button type="primary" icon="el-icon-plus" @click="showTypeDialog('add')">新增类型</el-button>
        </div>

        <el-table :data="typeList" border stripe>
          <el-table-column prop="id" label="ID" width="80"></el-table-column>
          <el-table-column prop="typeCode" label="类型编码" width="150"></el-table-column>
          <el-table-column prop="typeName" label="类型名称" width="150"></el-table-column>
          <el-table-column prop="description" label="描述"></el-table-column>
          <el-table-column prop="status" label="状态" width="100">
            <template slot-scope="scope">
              <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'">
                {{ scope.row.status === 1 ? '启用' : '停用' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200" fixed="right">
            <template slot-scope="scope">
              <el-button size="mini" @click="showTypeDialog('edit', scope.row)">编辑</el-button>
              <el-button size="mini" type="danger" @click="deleteType(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>

      <!-- 字典数据管理 -->
      <el-tab-pane label="字典数据" name="data">
        <div class="toolbar">
          <el-select v-model="selectedTypeCode" placeholder="选择字典类型" @change="loadDataList" clearable>
            <el-option
              v-for="type in typeList"
              :key="type.typeCode"
              :label="type.typeName"
              :value="type.typeCode">
            </el-option>
          </el-select>
          <el-button type="primary" icon="el-icon-plus" @click="showDataDialog('add')" :disabled="!selectedTypeCode">新增数据</el-button>
        </div>

        <el-table :data="dataList" border stripe>
          <el-table-column prop="id" label="ID" width="80"></el-table-column>
          <el-table-column prop="typeCode" label="类型编码" width="150"></el-table-column>
          <el-table-column prop="dataCode" label="数据编码" width="150"></el-table-column>
          <el-table-column prop="dataValue" label="数据值" width="150"></el-table-column>
          <el-table-column prop="sortOrder" label="排序" width="100"></el-table-column>
          <el-table-column prop="status" label="状态" width="100">
            <template slot-scope="scope">
              <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'">
                {{ scope.row.status === 1 ? '启用' : '停用' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注"></el-table-column>
          <el-table-column label="操作" width="200" fixed="right">
            <template slot-scope="scope">
              <el-button size="mini" @click="showDataDialog('edit', scope.row)">编辑</el-button>
              <el-button size="mini" type="danger" @click="deleteData(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>

    <!-- 字典类型对话框 -->
    <el-dialog :title="typeDialogTitle" :visible.sync="typeDialogVisible" width="500px">
      <el-form :model="typeForm" :rules="typeRules" ref="typeForm" label-width="100px">
        <el-form-item label="类型编码" prop="typeCode">
          <el-input v-model="typeForm.typeCode" :disabled="typeDialogMode === 'edit'" placeholder="如：college_level"></el-input>
        </el-form-item>
        <el-form-item label="类型名称" prop="typeName">
          <el-input v-model="typeForm.typeName" placeholder="如：学校层次"></el-input>
        </el-form-item>
        <el-form-item label="描述">
          <el-input v-model="typeForm.description" type="textarea" rows="3"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="typeForm.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="typeDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitType">确定</el-button>
      </span>
    </el-dialog>

    <!-- 字典数据对话框 -->
    <el-dialog :title="dataDialogTitle" :visible.sync="dataDialogVisible" width="500px">
      <el-form :model="dataForm" :rules="dataRules" ref="dataForm" label-width="100px">
        <el-form-item label="字典类型" prop="typeCode">
          <el-select v-model="dataForm.typeCode" :disabled="dataDialogMode === 'edit'" placeholder="选择字典类型">
            <el-option
              v-for="type in typeList"
              :key="type.typeCode"
              :label="type.typeName"
              :value="type.typeCode">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="数据编码" prop="dataCode">
          <el-input v-model="dataForm.dataCode" :disabled="dataDialogMode === 'edit'" placeholder="如：benke"></el-input>
        </el-form-item>
        <el-form-item label="数据值" prop="dataValue">
          <el-input v-model="dataForm.dataValue" placeholder="如：本科"></el-input>
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="dataForm.sortOrder" :min="0"></el-input-number>
        </el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="dataForm.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="dataForm.remark" type="textarea" rows="3"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dataDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitData">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { dictTypeApi, dictDataApi } from '@/api/dict'

export default {
  name: 'DictManageV2',
  data() {
    return {
      activeTab: 'type',
      
      // 字典类型
      typeList: [],
      typeDialogVisible: false,
      typeDialogMode: 'add',
      typeForm: {
        id: null,
        typeCode: '',
        typeName: '',
        description: '',
        status: 1
      },
      typeRules: {
        typeCode: [{ required: true, message: '请输入类型编码', trigger: 'blur' }],
        typeName: [{ required: true, message: '请输入类型名称', trigger: 'blur' }]
      },

      // 字典数据
      dataList: [],
      selectedTypeCode: '',
      dataDialogVisible: false,
      dataDialogMode: 'add',
      dataForm: {
        id: null,
        typeCode: '',
        dataCode: '',
        dataValue: '',
        sortOrder: 0,
        status: 1,
        remark: ''
      },
      dataRules: {
        typeCode: [{ required: true, message: '请选择字典类型', trigger: 'change' }],
        dataCode: [{ required: true, message: '请输入数据编码', trigger: 'blur' }],
        dataValue: [{ required: true, message: '请输入数据值', trigger: 'blur' }]
      }
    }
  },
  computed: {
    typeDialogTitle() {
      return this.typeDialogMode === 'add' ? '新增字典类型' : '编辑字典类型'
    },
    dataDialogTitle() {
      return this.dataDialogMode === 'add' ? '新增字典数据' : '编辑字典数据'
    }
  },
  mounted() {
    this.loadTypeList()
  },
  watch: {
    // 当字典类型列表加载完成后，自动选中第一个
    typeList(newVal) {
      if (newVal && newVal.length > 0 && !this.selectedTypeCode) {
        this.selectedTypeCode = newVal[0].typeCode
        this.loadDataList()
      }
    }
  },
  methods: {
    // 加载字典类型列表
    async loadTypeList() {
      try {
        const res = await dictTypeApi.list()
        if (res.data.code === 200) {
          this.typeList = res.data.data
        }
      } catch (error) {
        this.$message.error('加载字典类型失败')
      }
    },

    // 显示字典类型对话框
    showTypeDialog(mode, row = null) {
      this.typeDialogMode = mode
      if (mode === 'add') {
        this.typeForm = {
          id: null,
          typeCode: '',
          typeName: '',
          description: '',
          status: 1
        }
      } else {
        this.typeForm = { ...row }
      }
      this.typeDialogVisible = true
    },

    // 提交字典类型
    async submitType() {
      this.$refs.typeForm.validate(async (valid) => {
        if (valid) {
          try {
            const api = this.typeDialogMode === 'add' ? dictTypeApi.add : dictTypeApi.update
            const res = await api(this.typeForm)
            if (res.data.code === 200) {
              this.$message.success(res.data.message)
              this.typeDialogVisible = false
              this.loadTypeList()
            } else {
              this.$message.error(res.data.message)
            }
          } catch (error) {
            this.$message.error('操作失败')
          }
        }
      })
    },

    // 删除字典类型
    deleteType(id) {
      this.$confirm('确定要删除该字典类型吗？删除后相关的字典数据也会失效', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const res = await dictTypeApi.delete(id)
          if (res.data.code === 200) {
            this.$message.success('删除成功')
            this.loadTypeList()
          } else {
            this.$message.error(res.data.message)
          }
        } catch (error) {
          this.$message.error('删除失败')
        }
      })
    },

    // 加载字典数据列表
    async loadDataList() {
      if (!this.selectedTypeCode) {
        this.dataList = []
        return
      }
      try {
        const res = await dictDataApi.listByType(this.selectedTypeCode)
        if (res.data.code === 200) {
          this.dataList = res.data.data
        }
      } catch (error) {
        this.$message.error('加载字典数据失败')
      }
    },

    // 显示字典数据对话框
    showDataDialog(mode, row = null) {
      this.dataDialogMode = mode
      if (mode === 'add') {
        this.dataForm = {
          id: null,
          typeCode: this.selectedTypeCode || '',
          dataCode: '',
          dataValue: '',
          sortOrder: 0,
          status: 1,
          remark: ''
        }
      } else {
        this.dataForm = { ...row }
      }
      this.dataDialogVisible = true
    },

    // 提交字典数据
    async submitData() {
      this.$refs.dataForm.validate(async (valid) => {
        if (valid) {
          try {
            const api = this.dataDialogMode === 'add' ? dictDataApi.add : dictDataApi.update
            const res = await api(this.dataForm)
            if (res.data.code === 200) {
              this.$message.success(res.data.message)
              this.dataDialogVisible = false
              this.loadDataList()
            } else {
              this.$message.error(res.data.message)
            }
          } catch (error) {
            this.$message.error('操作失败')
          }
        }
      })
    },

    // 删除字典数据
    deleteData(id) {
      this.$confirm('确定要删除该字典数据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const res = await dictDataApi.delete(id)
          if (res.data.code === 200) {
            this.$message.success('删除成功')
            this.loadDataList()
          } else {
            this.$message.error(res.data.message)
          }
        } catch (error) {
          this.$message.error('删除失败')
        }
      })
    }
  }
}
</script>

<style scoped>
.dict-manage {
  padding: 20px;
}

.toolbar {
  margin-bottom: 20px;
}

.toolbar .el-select {
  width: 200px;
  margin-right: 10px;
}
</style>
